import styled from "styled-components";
import { Icon_CircleError } from "../common/CommonIcons";
import { Typography } from "@mui/material";
import { useModalStore } from "src/stores/ModalStore";
import { AlertSpan, CommonButton, NextButton } from "../common/CommonStyled";
import InputBoxOnChange from "../inputbox/InputBoxOnChange";
import { useState } from "react";
import { deleteUser } from "src/api/User";
import { ModalContentBlock, ModalFooterBlock, ModalTitleBlock } from "src/pages/LoginPage/LoginModalField";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useStorageStore } from "src/stores/StorageStore";
import { useNavbarStore } from "src/stores/UIStore";

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: center;
    width: 100%;
    justify-content: center;
    font-weight: 600;
    gap: 12px;
`

const ContentWrapper = styled.div`
    margin-top: 16px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    margin-top: 16px;
`
const InputContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin-top: 16px;
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 45px;
`;

const Label = styled(Typography)({
  color: '#7F7F89',
  fontSize: '14px',
  paddingBottom: '10px'
})
export const ModalTitleDelete = (
    <TitleWrapper>
        <Icon_CircleError/>
        정말 탈퇴하시겠어요?
    </TitleWrapper>
)

export const ModalContentDelete = (
    <ContentWrapper>
        비밀번호를 입력하시면 계정 탍퇴가 완료됩니다.<br/>
        탈퇴하면 계정은 영구 삭제되어 복구가 불가능합니다. 
        개인정보는 즉시 파기되며, 업무 기록 보존 목적으로
        홍보 기록과 최소한의 접속 로그만 보존됩니다.
    </ContentWrapper>
)

export const ModalFooterDelete = ()=>{
    const modalSetField = useModalStore((state)=>state.setField)
    const navigate = useNavigate()
    const [value,setValue] = useState('')
    const [passwordCorrect,setpasswordCorrect] = useState(false)
    const clear = useStorageStore((state) => state.clear);
    const setField = useNavbarStore((state) => state.setField);


    const onClickDelete = async (password:string)=>{
        const response = await deleteUser(password)
        if(response.status !== 200){
            setpasswordCorrect(true)
        }
        if(response.status === 424){
            navigate('/')
            setField('isvisible',false)
            modalSetField('title',ModalTitleBlock)
            modalSetField('content',ModalContentBlock)
            modalSetField('footer',<ModalFooterBlock />)
            clear()
        }
        if (response.status === 200){
            setField('isvisible',false)
            clear()
            navigate('/')
            handleSuccess()
            modalSetField('open',false)
        }
    }

    const handleSuccess = ()=>{
        toast.success('계정 탈퇴가 완료되었습니다.',{
            autoClose:2000
        })
    }
    return(
        <>
        <InputContainer>
          <Label>비밀번호</Label>
          <FlexRow>
          <InputBoxOnChange type="password" value={value} onChange={(e)=>setValue(e.target.value)}/>
          </FlexRow>
          { passwordCorrect && <AlertSpan $isValid={false}>비밀번호가 올바르지 않습니다.</AlertSpan>}
        </InputContainer>
        <ButtonWrapper>
            <CommonButton style={{backgroundColor:'#E3E3E3', color:'black', minWidth:'96px', width:'96px', padding:'10px'}} onClick={()=>modalSetField('open',false)}>취소</CommonButton>
            <NextButton disabled={!value} onClick={()=>onClickDelete(value)}>탈퇴</NextButton>
        </ButtonWrapper>
        </>
    )
}